// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#mw .sharable-dasboards__alert-message {
    max-width: 400px;
}
`, "",{"version":3,"sources":["webpack://./public/js/components/manager/style.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB","sourcesContent":["#mw .sharable-dasboards__alert-message {\n    max-width: 400px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
